import axios from 'axios';
import { APP_NAME } from '../helpers/constants';
import { apiRequest } from '../helpers/axiosClient';

const url = process.env.REACT_APP_OPW_SERVICE_API_ENDPOINT;

export const getToken = async (_email: string | null = null, _password: string | null = null) => {
  let email = process.env.REACT_APP_OPW_SERVICE_LOGIN_EMAIL;
  let password = process.env.REACT_APP_OPW_SERVICE_LOGIN_PASSWORD;
  if (_email) email = _email;
  if (_password) password = _password;

  const loginRequest = await apiRequest<any>('POST', `${url}/auth/login`, { email, password });

  if (loginRequest?.data?.access_token) {
    return loginRequest?.data?.access_token;
  } else {
    return null;
  }
};

export const getMe = async (token: string) => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const request = await apiRequest<any>('GET', `${url}/users/me`, undefined, headers);
  if (request?.data) {
    if (
      !request?.data?.data?.user?.userRoleList
        .map((obj: any) => obj.application.toLowerCase().trim())
        .includes(APP_NAME.toLowerCase().trim())
    ) {
      throw new Error('User role does not exists');
    }
    return request.data;
  } else {
    return null;
  }
};

export const microsoftLogin = async (token: string) => {
  const request = await apiRequest<any>('POST', `${url}/auth/social/microsoft`, { token });

  if (request?.data) {
    return request.data;
  } else {
    return null;
  }
};

// There IS a backend logout endpoint in opw-service (confirmed by dev review
// on OCIT-58, correcting an earlier assumption). It should be called on
// logout to invalidate the session/token server-side, in addition to the
// client-side state/localStorage clear.
// Note: this is a GET endpoint, not POST (corrected per dev review).
export const logout = async (token: string) => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const request = await apiRequest<any>('GET', `${url}/auth/logout`, undefined, headers);
  if (request?.data) {
    return request.data;
  } else {
    return null;
  }
};
